<template>
  <div class="userAgreement">
    <div style="word-break:break-all;" v-html="decodeStrUa"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      decodeStrUa:''
    }
  },
  created () {
    document.title = '用户协议'
    if (this.environment.isFengChao) {
      this.$cjc.showNavigation()
    }
    this.getAppUserPrivacy()
  },
  methods: {
    async getAppUserPrivacy () {
      const { data: { result, status, msg } } = await this.$store.dispatch('getAppUserPrivacy', {})
      console.log(result);
      if (status === 1000) {
        this.decodeStrUa = result.decodeStrUa
      } else {
        this.$Message.error(msg)
      }
    }
  }
}
</script>

<style lang="scss">
.userAgreement {
  height: 100vh;
  padding: 20px;
}
</style>